module.exports = __webpack_public_path__ + "static/media/sun.c0142ee6.png";